module.exports = __webpack_public_path__ + "static/media/conclusion-icon.517ec212.svg";